module.exports = __webpack_public_path__ + "static/img/user_interface_.e8d33d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/antarmuka-user/img/user_interface_.png
// module id = VTOz
// module chunks = 1